import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProjectContentItemDc } from "@evergis/api";

import { getLayersOpacity, getVisibleLayers } from "../../../ducks/sharedLayers/selectors";
import { setVisibleLayers } from "../../../ducks/sharedLayers/sharedLayers";
import { combineLayers } from "../../../hooks/project/useProjectLayers";

export const useSyncLayersVisibility = (layers: ProjectContentItemDc[]) => {
  const dispatch = useDispatch();
  const visibleLayersState = useSelector(getVisibleLayers);
  const layersOpacity = useSelector(getLayersOpacity);
  const combinedLayers = combineLayers(layers, { onlyVisible: true });

  const visibleLayers = useMemo(
    () => combinedLayers?.filter(({ isVisible }) => isVisible).map(({ name }) => name),
    [combinedLayers],
  );

  useEffect(() => {
    if (!visibleLayersState?.length && visibleLayers) {
      dispatch(setVisibleLayers(visibleLayers));
    }
  }, [visibleLayersState?.length, visibleLayers]);

  return useMemo(
    () =>
      combinedLayers?.length
        ? combinedLayers
            .map(layer => ({
              ...layer,
              isVisible: visibleLayersState?.includes(layer.name),
              opacity: layersOpacity?.[layer.name] !== undefined ? layersOpacity[layer.name] : layer.opacity,
            }))
            .reverse()
        : [],
    [combinedLayers, layersOpacity, visibleLayersState],
  );
};
